<script setup>
import { useGlobalStore } from '@stores/global'

const global = useGlobalStore()
</script>
<template>
	<div class="bg-bgSecondary">
		<section class="container flex flex-col items-center gap-10 text-center">
			<div class="flex max-w-[650px] flex-col items-center gap-4">
				<h4 class="font-regular">The Garden Keepers</h4>
				<p class="text">Every great garden needs a little tending, and our team is here to keep things thriving. From cultivating ideas to growing the community, we make sure Garden Mother stays fresh, fun, and always in full bloom.</p>
			</div>
			<div class="flex flex-wrap justify-center gap-6 pt-6">
				<div v-for="teamMember of global.team" class="flex flex-col text-start">
					<div class="relative rounded-lg border border-sf-purple-base p-16 overflow-hidden">
						<svg class="absolute bottom-0 left-0 right-0 top-0" width="1000" height="1000" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<rect width="1000" height="1000" fill="url(#pattern0_205_5986)" fill-opacity="0.7" />
							<defs>
								<pattern id="pattern0_205_5986" patternUnits="userSpaceOnUse" patternTransform="matrix(12.8 0 0 12.8 0 0)" preserveAspectRatio="none" viewBox="0 0 16 16" width="1" height="1">
									<g id="pattern0_205_5986_inner">
										<rect width="2" height="2" fill="white" fill-opacity="0.1" />
									</g>
								</pattern>
							</defs>
						</svg>
						<img :src="teamMember.image" alt="" class="aspect-square w-24 rounded-full object-cover mix-blend-luminosity" />
					</div>
					<span class="mt-4 text-h6 font-medium uppercase text-text-muted/50">{{ teamMember.role }}</span>
					<span class="text-h5 font-semibold uppercase text-text-base">{{ teamMember.name }}</span>
				</div>
			</div>
		</section>
	</div>
</template>
